import { render, staticRenderFns } from "./GSvg.vue?vue&type=template&id=fdc763b0&"
import script from "./GSvg.vue?vue&type=script&lang=js&"
export * from "./GSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports